.root {
  composes: page from './utils.module.css';
  display: flex;
  flex-direction: column;
}

.service {
  display: flex;
  align-items: flex-start;
  margin-top: 1rem;
}

.service + .service {
  margin-top: 2rem;
}

.heading {
  composes: heading from './utils.module.css';
}

.icon {
  flex: none;
  color: var(--color-gray);
  font-size: 5em;
  margin-right: 2rem;
}

.content {
  flex: 1 1 0%;
}

@media (min-height: 35em) {
  .service + .service {
    margin-top: 2.5rem;
  }

  .heading {
    font-size: 1.675em;
  }

  .icon {
    font-size: 6em;
  }
}

@media (min-width: 100em) and (min-height: 60em) {
  .service + .service {
    margin-top: 3rem;
  }

  .heading {
    font-size: 1.75em;
  }

  .icon {
    font-size: 8em;
  }

  .content {
    font-size: 1.25em;
  }
}
